import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ServerService } from "../server.service";
@Component({
  selector: 'app-encuestas-libres',
  templateUrl: './encuestas-libres.component.html',
  styleUrls: ['./encuestas-libres.component.css']
})
export class EncuestasLibresComponent implements OnInit {
    listadeencuestaslibres:any[];
    listadenombres:any;
    id:number
    ruta:string
  constructor( private server: ServerService,private router: Router ) {

  }

  ngOnInit(): void {

    this.ObtenerEncuestasLibres();
  }
/// este metodo va a traer solo las encuestas que tienen la bandera de visibilidad libre habilitada

ObtenerEncuestasLibres():void {
    this.server.getEncuestaslibres().subscribe((res:any)=>{
        this.listadeencuestaslibres= res;
     })

  }

}
